import React, { useEffect, useRef, useState } from "react";
import "../../fonts/Futura-PT-Book.ttf";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import styles from "./CartDetails.module.css";

import { useNavigate } from "react-router-dom";
import amazonpay from "../../assets/images/amazonpay.png";
import paypaynew from "../../assets/images/paypaynew.png";
import rpay from "../../assets/images/rpay.png";
import useAxios from "../Hooks/useAxios";

import $ from "jquery";
import moment from "moment-timezone";
import Swal from "sweetalert2";

import hex_md5 from "./md5";
import Sha1 from "./sha1";

import arrow from "../../assets/images/icons/selector_down_arrow.png";
import paymentSubmit from "../../customHooks/paymentHooks/paymentHook";
const CartDetails = () => {
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const frontend_base = process.env.REACT_APP_FRONTEND_URL;
  const navigate = useNavigate();
  const axios = useAxios();
  const firstDivRef = useRef(null);
  const secondDivRef = useRef(null);
  const [showProducts, setShowProducts] = useState(false);
  const [productList, setProductList] = useState([]);
  const [defaultAddress, setDefaultAddress] = useState(false);
  const [address1, setAddress1] = useState(false);
  const [address2, setAddress2] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [bulkAddressSelected, setBulkAddressSelected] = useState("会員様住所");
  const [addressListAll, setAddressListAll] = useState([]);
  const [newAddressPopup, setNewAddressPopup] = useState(false);
  const [popupHeader, setPopupHeader] = useState("新しい住所を追加する");
  const [popupRedText, setPopupRedText] = useState("別送住所２に登録します");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const paymentOptions = [
    {
      value: "credit",
      label: "クレジットカード",
    },
    {
      value: "paypay",
      label: "PayPay",
      icon: paypaynew,
      iconStyle: "payment_icon01",
      subtext: "PayPayでお支払いができます。",
    },
    {
      value: "rakuten",
      label: "楽天PAY",
      icon: rpay,
      iconStyle: "payment_icon02",
      subtext: "楽天IDでお支払いができます。",
    },
    {
      value: "alipay",
      label: "Amazonペイ",
      icon: amazonpay,
      iconStyle: "payment_icon03",
      subtext: "Amazonアカウントでお支払いができます。",
    },
    {
      value: "banktransfer",
      label: "銀行振込",
      subtext: "振込確認後、アイテム編集が可能となります。ご了承下さい。",
    },
  ];

  useEffect(() => {
    const updateWindowDimensions = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", updateWindowDimensions);

    return () => {
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  useEffect(() => {
    const firstDivRight = firstDivRef.current.getBoundingClientRect().right;
    secondDivRef.current.style.left = `${firstDivRight + 36}px`;
  }, [windowWidth]);

  const [shippingCostings, setShippingCostings] = useState({});

  const [subPrices, setSubPrices] = useState([
    { text: "商品合計金額", price: 0 },
    { text: "送料", price: 0 },
    { text: "値引き", price: 0 },
  ]);

  const [totalPrice, setTotalPrice] = useState(0);

  const changeBulkAddress = (newAddress) => {
    const temp = JSON.parse(JSON.stringify(productList));
    for (let i = 0; i < productList.length; i++) {
      temp[i].address = newAddress;
    }
    //console.log(temp);
    //console.log(newAddress);
    setProductList(temp);
    setBulkAddressSelected(newAddress);
  };

  const bulkChangeOption = (index, address) => {
    const uniqueAddresses = new Set();
    const temp = JSON.parse(JSON.stringify(productList));
    temp[index].address = address;
    temp[index].option_popup = false;
    temp.forEach((item) => {
      uniqueAddresses.add(item.address);
    });
    let tempSubPrices = subPrices;
    if (uniqueAddresses.size === 1) {
      tempSubPrices[1].price = shippingCostings?.place_1;
    } else if (uniqueAddresses.size === 2) {
      tempSubPrices[1].price = shippingCostings?.place_2;
    } else if (uniqueAddresses.size === 3) {
      tempSubPrices[1].price = shippingCostings?.place_3;
    }
    setTotalPrice(subPrices[0].price + subPrices[1].price - subPrices[2].price);
    setSubPrices(tempSubPrices);
    setProductList(temp);
  };
  const bulkChangePopupAlter = (index) => {
    const temp = JSON.parse(JSON.stringify(productList));
    temp[index].option_popup = !temp[index].option_popup;
    setProductList(temp);
  };

  useEffect(() => {
    setOrderId(hex_md5(getYYYYMMDDHHMMSS()));
  }, []);

  const confirmOrder = () => {
    if (paymentMethod.length === 0) {
      Swal.fire({
        title: "誤り",
        text: "支払い方法を追加選択する必要があります。",
        icon: "error",
        confirmButtonText: "オーケー",
      });
      // alert("支払い方法を追加選択する必要があります。");
      return;
    }
    const data = {
      product_list: productList,
      payment_by: paymentMethod,
      order_id: orderId,
      totalPrice: totalPrice
    };
    //console.log("Trying to confirm order", data);

    axios
      .post(backend_base + "/order/confirm", data)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          //console.log("Success Confirming Cart");
          //console.log(res.data);
          if (data?.payment_by == 'banktransfer') {
            navigate("/purchase-success", {
              state: { paymentMethod, fromOnlineShopPurchase: true },
            });
          } else {
            paymentSubmit(data);
          }
        } else {
          //console.log("Failed");
        }
      })
      .catch((e) => {
        //console.log(e);
      });
  };

  const [dataReload, setDataReload] = useState(false);

  useEffect(() => {
    axios
      .get(backend_base + "/order/confirm")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log(res.data);
          console.log(
            res.data.default_address,
            res.data.address_01,
            res.data.address_02,
            "sadflk;asdfksdflasdlfsadf"
          );
          const temp_sub_price = JSON.parse(JSON.stringify(subPrices));
          temp_sub_price[0].price = res.data?.sub_total_bill;
          temp_sub_price[1].price = res.data?.shipping_costings?.place_1;
          temp_sub_price[2].price = res.data?.discount;
          setSubPrices(temp_sub_price);
          setTotalPrice(
            temp_sub_price[0].price +
              temp_sub_price[1].price -
              temp_sub_price[2].price
          );
          setShippingCostings(res.data?.shipping_costings);
          const tempAddressList = [];
          if (res.data.default_address) {
            const addrs = res.data.default_address;
            tempAddressList.push(addrs);
            setDefaultAddress(true);
          }
          if (
            res.data.address_01 &&
            Object.keys(res.data.address_01).length > 0
          ) {
            const addrs = res.data.address_01;
            tempAddressList.push(addrs);
            setAddress1(true);
          }
          if (
            res.data.address_02 &&
            Object.keys(res.data.address_02).length > 0
          ) {
            const addrs = res.data.address_02;
            tempAddressList.push(addrs);
            setAddress2(true);
          }
          //console.log("ADDRESS LIST");
          //console.log(tempAddressList);
          setAddressListAll(tempAddressList);

          const tempProductList = [];
          for (let i = 0; i < res.data.cart.length; i++) {
            const p = res.data.cart[i];
            if (p.quantity === 1) {
              tempProductList.push({
                title: p.product.product_code_jp,
                original_product: p,
                address: bulkAddressSelected,
                option_popup: false,
              });
            } else {
              for (let j = 0; j < p.quantity; j++) {
                tempProductList.push({
                  title:
                    p.product.product_code_jp + (j + 1).toString() + "冊目",
                  original_product: p,
                  address: bulkAddressSelected,
                  option_popup: false,
                });
              }
            }
          }
          //console.log("MY product list:");
          //console.log(tempProductList);
          setProductList(tempProductList);
        } else {
          //console.log("Failed");
        }
      })
      .catch((e) => {
        //console.log(e);
      });
  }, [dataReload]);

  const initAddress = {
    postal_code: "",
    prefecture: "",
    municipality: "",
    Building_number: "",
    phone: "",
    type: 0,
    kanji_first_name: "",
    kanji_last_name: "",
    furigana_first_name: "",
    furigana_last_name: "",
  };

  const [newAddressData, setNewAddressData] = useState({ ...initAddress });

  const handleAddressChange = (e) => {
    let temp = JSON.parse(JSON.stringify(newAddressData));
    temp[e.target.name] = e.target.value;
    setNewAddressData(temp);
  };

  const fetchAddressByZipCode = () => {
    let value = newAddressData.postal_code;
    let zipsearch = value;
    if (value.length > 7) {
      zipsearch = value.replace(/[- ]/g, "");
    }
    zipsearch = parseInt(zipsearch);
    axios
      .post(backend_base + "/user/get/jp/address", {
        zipcode: zipsearch,
      })
      .then((response) => {
        if (response.status === 200) {
          //goto next page
          const result = response.data.address_data.results[0];
          //console.log(result);

          setNewAddressData({
            ...newAddressData,
            prefecture: result["address1"],
            municipality: result["address2"] + " " + result["address3"],
            postal_code: value,
          });
        }
      })
      .catch((error) => {
        //console.log(error);
      });
  };

  const handleAddOrEditAddressConfirm = () => {
    //console.log(newAddressData);
    //console.log(addressListAll.length);
    let apiEndPoint = "";
    if (popupHeader === "新しい住所を追加する") {
      if (addressListAll.length === 1) {
        apiEndPoint = "address-one";
      } else if (addressListAll.length === 2) {
        apiEndPoint = "address-two";
      }
      //console.log(apiEndPoint);
      axios
        .post(backend_base + "/user/" + apiEndPoint, {
          ...newAddressData,
        })
        .then((res) => {
          if (res.status === 201 || res.status === 200) {
            //console.log("Address Added");
            setNewAddressData({ ...initAddress });
            setAddressListAll([...addressListAll, newAddressData]);
            setDataReload(!dataReload);
            setNewAddressPopup(false);
          } else {
            //console.log("Failed");
          }
        })
        .catch((e) => {
          //console.log(e);
        });
    } else {
      let type = 0;
      if (newAddressData.Address_type === 0) {
        apiEndPoint = "address-default";
        type = 0;
      } else if (newAddressData.Address_type === 1) {
        apiEndPoint = "address-one";
        type = 1;
      } else if (newAddressData.Address_type === 2) {
        apiEndPoint = "address-two";
        type = 2;
      }
      axios
        .put(backend_base + "/user/" + apiEndPoint, {
          ...newAddressData,
          type: type,
        })
        .then((res) => {
          if (res.status === 200) {
            //console.log("Address Edited");
            setNewAddressData({ ...initAddress });
            setAddressListAll([...addressListAll, newAddressData]);
            setDataReload(!dataReload);
            setNewAddressPopup(false);
          } else {
            //console.log("Failed");
          }
        })
        .catch((e) => {
          //console.log(e);
        });
    }
  };

  const handleEditAddress = (buttonName) => {
    //console.log(buttonName);
    setNewAddressPopup(true);
    setPopupHeader("会員情報の変更");
    setPopupRedText("会員情報も上記の内容で更新します");
    if (buttonName === "会員住所を変更") {
      setNewAddressData({
        ...addressListAll[0],
        type: " default",
      });
      //console.log(addressListAll, "defaultAddress");
    } else if (buttonName === "別送住所1を変更") {
      setNewAddressData({
        ...addressListAll[1],
        type: " 1",
      });
    } else if (buttonName === "別送住所2を変更") {
      setNewAddressData({
        ...addressListAll[2],
        type: " 2",
      });
    }
  };

  const handleChangePaymentMethod = (e) => {
    //console.log(e.target.value);
    setPaymentMethod(e.target.value);
  };

  const getYYYYMMDDHHMMSS = () => {
    return moment().tz("Asia/Tokyo").format("YYYYMMDDHHmmss");
  };


  return (
    <>
      {newAddressPopup && (
        <div className={styles.add_address_main_wrapper}>
          <div
            onClick={() => {
              setNewAddressPopup(false);
              setNewAddressData({ ...initAddress });
            }}
            className={styles.add_address_background}
          ></div>
          <form
            className={styles.add_address_main}
            onSubmit={(e) => {
              e.preventDefault();
              handleAddOrEditAddressConfirm();
            }}
          >
            <div className={styles.ad_header01}>{popupHeader}</div>
            <div className={styles.ad_header02}>
              {"別送住所" + newAddressData.type}
            </div>
            <div className={styles.ad_hr}></div>
            <div className={styles.info_row_main_wrapper}>
              <div className={styles.col1_main}>
                <div className={styles.col1_row1}>
                  <div className={styles.col1_label}>お名前</div>
                  <div className={styles.col1_input_row1}>
                    <input
                      required
                      value={newAddressData.kanji_first_name}
                      name="kanji_first_name"
                      onChange={handleAddressChange}
                      className={styles.input_sm01}
                    ></input>
                    <input
                      required
                      value={newAddressData.kanji_last_name}
                      name="kanji_last_name"
                      onChange={handleAddressChange}
                      className={styles.input_sm01}
                    ></input>
                  </div>
                </div>
                <div className={styles.col1_row1}>
                  <div className={styles.col1_label}>ふりがな</div>
                  <div className={styles.col1_input_row1}>
                    <input
                      required
                      value={newAddressData.furigana_first_name}
                      name="furigana_first_name"
                      onChange={handleAddressChange}
                      className={styles.input_sm01}
                    ></input>
                    <input
                      required
                      value={newAddressData.furigana_last_name}
                      name="furigana_last_name"
                      onChange={handleAddressChange}
                      className={styles.input_sm01}
                    ></input>
                  </div>
                </div>
                <div className={styles.col1_row1}>
                  <div className={styles.col1_label}>携帯電話</div>
                  <div className={styles.col1_input_row1}>
                    <input
                      required
                      value={newAddressData.phone}
                      name="phone"
                      onChange={handleAddressChange}
                      className={styles.input_sm01}
                    ></input>
                  </div>
                </div>
              </div>
              <div className={styles.col2_main}>
                <div className={styles.row3_main}>
                  <div className={styles.row_label03}>郵便番号</div>
                  <div className={styles.input_row_03}>
                    <input
                      required
                      value={newAddressData.postal_code}
                      name="postal_code"
                      onChange={handleAddressChange}
                      className={styles.input_sm01}
                    />
                    <div
                      onClick={fetchAddressByZipCode}
                      className={styles.underline01}
                    >
                      郵便番号検索
                    </div>
                  </div>
                </div>
                <div className={styles.row3_main}>
                  <div className={styles.row_label03}>都道府県</div>
                  <div className={styles.input_row_03}>
                    <input
                      required
                      value={newAddressData.prefecture}
                      name="prefecture"
                      onChange={handleAddressChange}
                      className={styles.input_sm01}
                    />
                  </div>
                </div>
                <div className={styles.row4_main}>
                  <div className={styles.row_label03}>市区町村以下</div>
                  <div className={styles.input_row_03}>
                    <input
                      value={newAddressData.municipality}
                      name="municipality"
                      onChange={handleAddressChange}
                      className={styles.input_bg01}
                    />
                  </div>
                </div>
                <div className={styles.row4_main}>
                  <div className={styles.row_label03}>建物名</div>
                  <div className={styles.input_row_03}>
                    <input
                      value={newAddressData.Building_number}
                      name="Building_number"
                      onChange={handleAddressChange}
                      className={styles.input_bg01}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.add_btn_section}>
              <div
                onClick={() => {
                  setNewAddressPopup(false);
                  setNewAddressData({ ...initAddress });
                }}
                className={styles.btn99}
              >
                キャンセル
              </div>
              <div className={styles.ad_btn_2_main}>
                <input
                  type="submit"
                  value={"決　定"}
                  className={styles.btn98}
                />
                <div className={styles.ad_warning01}>{popupRedText}</div>
              </div>
            </div>
          </form>
        </div>
      )}
      <Header />
      <div className={styles.cart_details_main}>
        <div className={styles.fixed_price_box_main} ref={secondDivRef}>
          <div className={styles.fixed_price_box01}>
            <div className={styles.fixed_price_sub_main}>
              {subPrices.map((item, index) => {
                return (
                  <div key={index} className={styles.subprice_single_row}>
                    <div className={styles.subprice_single_row_text}>
                      {item.text}
                    </div>
                    <div className={styles.subprice_single_row_price}>
                      {new Intl.NumberFormat("ja-JP", {
                        style: "currency",
                        currency: "JPY",
                      }).format(item.price)}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className={styles.fixed_price_01_divider}></div>
            <div className={styles.fixed_price_01_total_main}>
              <div className={styles.fixed_price_01_total_main_row}>
                <div className={styles.fp_price_text}>商品合計</div>
                <div className={styles.fp_price_total}>
                  {new Intl.NumberFormat("ja-JP", {
                    style: "currency",
                    currency: "JPY",
                  }).format(totalPrice)}
                </div>
              </div>
            </div>
            <div
              onClick={() => {
                //confirm order here;
                if (!showProducts) {
                  setShowProducts(true);
                } else {
                  confirmOrder();
                }
              }}
              className={styles.button01}
              style={{ backgroundColor: showProducts ? "#5592D0" : "#44719f" }}
            >
              注文を確定する
            </div>
          </div>
        </div>
        <div className={styles.heading01}>ご注文内容の確認</div>
        <div className={styles.heading02}>※ご注文はまだ確定していません</div>
        <div className={styles.body_main}>
          <div className={styles.address_payment_section} ref={firstDivRef}>
            <div className={styles.address_box_wrapper}>
              <div className={styles.address_box_top_main}>
                <div className={styles.heading03}>配送先の指定</div>
                {!showProducts && (
                  <div
                    onClick={() => {
                      setShowProducts(true);
                    }}
                    className={styles.heading04}
                  >
                    複数の配送先に送る場合はこちら
                  </div>
                )}
              </div>
              <div className={styles.address_box_main}>
                {Array.isArray(addressListAll) &&
                  addressListAll.length > 0 &&
                  addressListAll.map((item, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          borderBottom:
                            index === 2 ? "none" : "1px solid #707070",
                        }}
                        className={styles.single_address_row}
                      >
                        <input
                          className={styles.radio}
                          type="radio"
                          key={index + 1}
                          name={"address"}
                          // defaultChecked={"会員様住所"}
                          checked={
                            index === 0
                              ? bulkAddressSelected === "会員様住所"
                              : index === 1
                              ? bulkAddressSelected === "別送住所１"
                              : bulkAddressSelected === "別送住所2"
                          }
                          onChange={(e) => {
                            if (index === 0) {
                              changeBulkAddress("会員様住所");
                            } else if (index === 1) {
                              changeBulkAddress("別送住所１");
                            } else if (index === 2) {
                              changeBulkAddress("別送住所2");
                            }
                          }}
                        />
                        <div className={styles.row_address_section}>
                          <div className={styles.row_text01}>
                            {index === 0 ? "会員様住所" : "別送住所" + index}
                          </div>
                          <div className={styles.row_text02}>
                            {item.kanji_first_name + " " + item.kanji_last_name}
                          </div>
                          <div className={styles.row_text02}>
                            {item.postal_code}
                          </div>
                          <div className={styles.row_text02}>
                            {item.municipality}
                          </div>
                          <div className={styles.row_text02}>{item.phone}</div>
                        </div>
                        <div
                          className={`${styles.row_tag} btn`}
                          onClick={() => {
                            handleEditAddress(
                              index === 0
                                ? "会員住所を変更"
                                : "別送住所" + index + "を変更"
                            );
                          }}
                        >
                          {index === 0
                            ? "会員住所を変更"
                            : "別送住所" + index + "を変更"}
                        </div>
                      </div>
                    );
                  })}

                {!showProducts && addressListAll.length < 3 && (
                  <div
                    onClick={() => {
                      setNewAddressPopup(true);
                      setPopupHeader("新しい住所を追加する");
                      setPopupRedText(
                        "別送住所" + addressListAll.length + "に登録します"
                      );
                      setNewAddressData({
                        ...newAddressData,
                        type: addressListAll.length,
                      });
                    }}
                    className={styles.box_another_address}
                  >
                    ＋新しい住所を追加
                  </div>
                )}
                {showProducts &&
                  Array.isArray(productList) &&
                  productList.length > 0 &&
                  productList.map((item, index) => {
                    return (
                      <div className={styles.single_product_row}>
                        <div className={styles.single_product_text}>
                          {item.title}
                        </div>
                        <div className={styles.address_selector_main_wrapper}>
                          <div
                            onClick={() => {
                              //handle action popup open and close
                              bulkChangePopupAlter(index);
                            }}
                            className={styles.address_selector_main}
                            style={{
                              borderBottomLeftRadius: item.option_popup
                                ? "0px"
                                : "9px",
                              borderBottomRightRadius: item.option_popup
                                ? "0px"
                                : "9px",
                            }}
                          >
                            <img
                              src={arrow}
                              className={styles.selector_first_icon}
                              alt="selector"
                            />
                            {item.address}
                          </div>
                          {item.option_popup && (
                            <div
                              className={styles.address_selectior_second_box}
                            >
                              {defaultAddress && (
                                <div
                                  onClick={() => {
                                    bulkChangeOption(index, "会員様住所");
                                  }}
                                  style={{
                                    borderBottomLeftRadius: address1
                                      ? "0px"
                                      : "9px",
                                    borderBottomRightRadius: address1
                                      ? "0px"
                                      : "9px",
                                  }}
                                  className={styles.selector_rest_box}
                                >
                                  会員様住所
                                </div>
                              )}
                              {address1 && (
                                <div
                                  onClick={() => {
                                    bulkChangeOption(index, "別送住所１");
                                  }}
                                  style={{
                                    borderBottomLeftRadius: address2
                                      ? "0px"
                                      : "9px",
                                    borderBottomRightRadius: address2
                                      ? "0px"
                                      : "9px",
                                  }}
                                  className={styles.selector_rest_box}
                                >
                                  別送住所１
                                </div>
                              )}
                              {address2 && (
                                <div
                                  onClick={() => {
                                    bulkChangeOption(index, "別送住所2");
                                  }}
                                  className={styles.selector_rest_box}
                                >
                                  別送住所2
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className={styles.payment_header}>お支払い方法</div>
            <div className={styles.payment_wrapper}>
              <div className={styles.payment_main_div}>
                {paymentOptions.map((option, index) => (
                  <div className={styles.payment_row} key={index}>
                    <div className={styles.payment_row_first_main}>
                      <input
                        className={styles.radio}
                        type="radio"
                        name={"paymentmethod"}
                        value={option.value}
                        onChange={(e) => {
                          handleChangePaymentMethod(e);
                        }}
                        onClick={(event) => {}}
                      />
                      <div className={styles.row_radio_text}>
                        {option.label}
                      </div>
                    </div>
                    <div className={styles.payment_row_second_main}>
                      {option.icon && (
                        <img
                          src={option.icon}
                          alt="img"
                          className={styles[option.iconStyle]}
                        />
                      )}
                      <div className={styles.row_payment_subtext}>
                        {option.subtext}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={styles.dummy_div01}></div>
        </div>
        <div className={styles.bottom_space}></div>
      </div>
      <Footer />
    </>
  );
};

export default CartDetails;
